import { createSlice } from '@reduxjs/toolkit';
import { UiState } from 'constants/ui';
import { stateName } from './constants';
export const initialState = {
  settings: {
    countryId: null,
    cityId: null,
    cityTitle: null,
    isCityVisible: false,
    about: undefined,
    languageCode: '',
    photoTempUuid: undefined,
    vat: null
  },
  uiState: UiState.Idle
};

const setInitialSettings = (draft, action) => {
  draft.settings = action.payload.settings;
};

const setCountryId = (draft, action) => {
  const {
    id
  } = action.payload;
  draft.settings.countryId = id;
};

const setCity = (draft, action) => {
  const {
    id,
    title
  } = action.payload;
  draft.settings.cityId = id;
  draft.settings.cityTitle = title;
};

const setIsCityVisible = (draft, action) => {
  draft.settings.isCityVisible = action.payload.isVisible;
};

const setAbout = (draft, action) => {
  draft.settings.about = action.payload.about;
};

const setLanguageCode = (draft, action) => {
  draft.settings.languageCode = action.payload.languageCode;
};

const setPhotoTempUuid = (draft, action) => {
  draft.settings.photoTempUuid = action.payload.photoTempUuid;
};

const setUsername = (draft, action) => {
  draft.settings.username = action.payload.username;
};

const setContactEmail = (draft, action) => {
  draft.settings.contactEmail = action.payload.contactEmail;
};

const setContactNumber = (draft, action) => {
  draft.settings.contactNumber = action.payload.contactNumber;
};

const setError = (draft, action) => {
  draft.error = action.payload.error;
};

const setVat = (draft, action) => {
  draft.settings.vat = action.payload.vat;
};

const changeUiState = (draft, action) => {
  const {
    uiState
  } = action.payload;
  draft.uiState = uiState;
};

const profileSettingsSlice = createSlice({
  name: stateName,
  initialState,
  reducers: {
    setInitialSettings,
    setCountryId,
    setCity,
    setIsCityVisible,
    setAbout,
    setLanguageCode,
    setPhotoTempUuid,
    setUsername,
    setContactEmail,
    setContactNumber,
    setError,
    setVat,
    changeUiState
  }
});
export const {
  actions
} = profileSettingsSlice;
export const plug = {
  [stateName]: profileSettingsSlice.reducer
};
export default profileSettingsSlice.reducer;